/* eslint-disable quotes */
/* eslint-disable semi */
import { storeMutations } from '../../mutations.constants';
import licenseState from "./state";

export const state = licenseState;
const mutations = {
  [storeMutations.HtmlContentSaveMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.message = res.data;
    }
  },
  [storeMutations.HtmlContentMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.htmlContent = res.data;
    }
  },
  
  
  };
export default { ...mutations };
